import React, { useContext } from 'react';

import { ArrowAngleRight } from '@zooplus/icons';

import LocResourcesContext from '../../common/contexts/LocResourcesContext';
import FiltersContext from '../contexts/FiltersContext';

import { FiltersDrawer } from './FiltersDrawer/FiltersDrawer';
import PetFilter from './PetFilter';

interface FiltersMenuProps {}

const FiltersMenu = ({}: FiltersMenuProps): JSX.Element => {
  const GLOBAL_PREFIX = 'loy-bp-rws-overview';
  const { showFilters, defaultView, onShowFilters } = useContext(FiltersContext);

  const { onFormatLocale } = useContext(LocResourcesContext);

  const moreFiltersCollapsed = () => {
    return (
      <button
        className={`${GLOBAL_PREFIX}_filter__more`}
        aria-label={`${onFormatLocale?.('loy.rewards.shop.filter.more')} ${onFormatLocale?.('loy.rewards.shop.filter.more.descriptive')}`}
        onClick={(e) => {
          onShowFilters?.(true, 'all');
        }}>
        {onFormatLocale?.('loy.rewards.shop.filter.more')}
        <ArrowAngleRight aria-hidden/>
      </button>
    );
  };

  return (
    <React.Fragment>
      <PetFilter />
      {moreFiltersCollapsed()}
      {showFilters && <FiltersDrawer view={defaultView} />}
    </React.Fragment>
  );
};

export default FiltersMenu;
